import {Directive, Input, OnChanges, OnInit, SimpleChanges, Type, ViewContainerRef} from "@angular/core";
import {SelectItem} from "../select-item";
import {SourceItem} from "../source-item";

@Directive({
    selector: '[SourceItemContainer]'
})
export class SourceItemDirective implements OnInit, OnChanges {
    @Input() item: SelectItem;
    @Input() fieldWrapperConfig;
    @Input() searchTerm: string;
    private componentRef;

    constructor(public viewContainerRef: ViewContainerRef) {

    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fieldWrapperConfig.currentValue && this.fieldWrapperConfig?.config.sourceItemComponent) {
            this.loadComponent(this.viewContainerRef, this.fieldWrapperConfig?.config.sourceItemComponent);
        }


    }

    private loadComponent(containerRef, component: Type<SourceItem>): void {
        const viewContainerRef = containerRef;
        containerRef._hostLView[0].classList.add('source-item');
        viewContainerRef?.clear();
        this.componentRef = viewContainerRef.createComponent(component);
        this.componentRef.instance.item = this.item;

    }
}
